module.exports = __webpack_public_path__ + "img/food_add.1363be73.svg";